module.exports = __webpack_public_path__ + "static/media/wallfinishes_gwp_10y_y.7b2cc72e.csv";